import ExternalCalendarDetail from "externalCalendar/Detail/app";
import ExternalCalendarList from "externalCalendar/List/ExternalCalendarList";
import ExternalCalendarNew from "externalCalendar/New/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const externalCalendarRoute: RouteObject = {
  path: "externalcalendar",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ExternalCalendarList,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: ExternalCalendarDetail,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: ExternalCalendarNew,
  }]
};